import { cEl } from '../../../../util';
import servingRobot from '../../../../assets/images/learn/serving-robot.png';
import miniRobot from '../../../../assets/images/learn/mini-delivery-robot.png';
import heavyWeightRobot from '../../../../assets/images/learn/heavy-weight-delivery-robot.png';
import outdoorRobot from '../../../../assets/images/learn/outdoor-delivery-robot.png';
import ServingRobot from './ServingRobot';
import MiniRobot from './MiniRobot';
import HeavyDeliveryRobot from './HeavyDeliveryRobot';
import OutdoorRobot from './OutdoorRobot';

function Delivery() {
    const article = cEl('article');
    article.classList.add('delivery', 'learn-section');

    const contents = cEl('div');
    contents.innerHTML = `
    <div class="learn-header">
        <h2>병원 서비스 로봇의 종류 1 : <span class="color-brand">배송 로봇</span></h2>
        <div class="img-container">
            <div class="img-wrapper">
                <img src="${servingRobot}" alt="serving robot">
                <span>서빙 로봇</span>
            </div>
            <div class="img-wrapper">
                <img src="${miniRobot}" alt="mini robot">
                <span>소형 배송 로봇</span>
            </div>
            <div class="img-wrapper">
                <img src="${heavyWeightRobot}" alt="heavy weight robot">
                <span>고중량 이송 로봇</span>
            </div>
            <div class="img-wrapper">
                <img src="${outdoorRobot}" alt="outdoor robot">
                <span>실외 배송 로봇</span>
            </div>
        </div>
    </div>`;

    const buttonWrapper = cEl('div');
    buttonWrapper.classList.add('button-wrapper');

    const moreButton = cEl('button');
    moreButton.classList.add('button', 'border-button');
    moreButton.innerHTML = '다양한 배송 로봇 둘러보기';
    moreButton.addEventListener('click', e => {
        window.open('https://www.myrobotsolution.com/store/delivery?categoryId=70', '_blank');
    });
    buttonWrapper.appendChild(moreButton);

    contents.append(ServingRobot(), MiniRobot(), HeavyDeliveryRobot(), OutdoorRobot(), buttonWrapper);

    article.appendChild(contents);

    return article;
}

export default Delivery;
